import React from 'react'
import axios from 'axios';
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from '../../../Notifications/ToastifyActions';

function FilterAmazonAlertService(token,data) {
    return axios.post(`${CURRENT_API_URL}/proactiveMonitoring/filterAmazonAlert`, data,{
    headers: {
        'Authorization': token,
    }
    })
    // .then(res => {
    //     notify.NotifySuccess("Task has been archived successfully. Thank You!");       
    //     return res.data;        
    // })
    .catch(error => {
        console.log(error);
        notify.NotifyError("An error occurred while archiving tasks. Please try again later.");
        return false;
    });
}

export default FilterAmazonAlertService;